import React from 'react';
import { useForbiddenPlansStore } from 'src/store/forbidden-plans';
import { Modal } from '../Modal';
import './AcceptanceWarningModal.scss';

export const ForbiddenPlansModal: React.FC = () => {
  const { isModalOpen, resolveForbiddenPlans, isProcessing, error } =
    useForbiddenPlansStore();

  const handleConfirm = async () => {
    try {
      await resolveForbiddenPlans();
    } catch (err) {
      // Error is handled in the store
    }
  };

  const handleClose = () => {
    // Don't allow closing without confirming
  };

  if (!isModalOpen) return null;

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleClose}
      className="acceptance-warning-modal"
      hideCloseButton={true}
      blockOverlayClick={true}
    >
      <div className="acceptance-warning">
        <div className="acceptance-warning__image">
          <img
            src="/images/modalUnderReview.jpg"
            alt="Plans not available"
            className="acceptance-warning__image-content"
          />
        </div>

        <div className="acceptance-warning__content">
          <div className="acceptance-warning__text">
            <p className="acceptance-warning__paragraph">
              Sorry, but one or more plans you selected are not available in
              your state. We'll refresh your available plans so you can
              continue.
            </p>
          </div>

          {error && (
            <p
              className="acceptance-warning__error"
              style={{ color: 'red', marginBottom: '16px' }}
            >
              {error}
            </p>
          )}

          <div className="acceptance-warning__actions">
            <button
              className="acceptance-warning__button acceptance-warning__button--proceed"
              onClick={handleConfirm}
              disabled={isProcessing}
            >
              {isProcessing ? 'Processing...' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
